import React from 'react';

interface TimeSelectProps {
    value: string[] | undefined; // Puede ser undefined
    onChange: (hours: string[]) => void;
    format: '12h' | '24h';
}

const TimeSelect: React.FC<TimeSelectProps> = ({ value = [], onChange, format }) => {
    const hours12 = [
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM',
        '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM',
        '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'
    ];

    const hours24 = [
        '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00',
        '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00',
        '20:00', '21:00', '22:00', '23:00'
    ];

    const hours = format === '12h' ? hours12 : hours24;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const hour = e.target.value;
        const currentValue = Array.isArray(value) ? value : []; // Aseguramos que siempre sea un array
        const newValue = e.target.checked ? [...currentValue, hour] : currentValue.filter(h => h !== hour);
        onChange(newValue);
    };

    return (
        <div className="grid grid-cols-4 gap-2">
            {hours.map((hour) => (
                <div key={hour} className="flex items-center space-x-2">
                    <input
                        type="checkbox"
                        value={hour}
                        checked={Array.isArray(value) && value.includes(hour)}
                        onChange={handleChange}
                        className="h-4 w-4 text-indigo-600"
                    />
                    <label>{hour}</label>
                </div>
            ))}
        </div>
    );
};

export default TimeSelect;
